import { Component, OnInit } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subscription } from 'rxjs';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import * as moment from 'moment';
import { CONST_AWS_API, API } from '../../../../../core/constants'
import { API as AWS_API } from 'aws-amplify';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { COLORLIST } from './../../../../../core/constants';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from 'src/app/core/services/storage.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AppService } from 'src/app/core/services/app.service';
import { UserService } from 'src/app/core/services/user.service';
import { EventCheckoutDialog } from '../event-tickets/event-tickets.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
declare let $: any;

@Component({
  selector: 'app-event-schedule',
  templateUrl: './event-schedule.component.html',
  styleUrls: ['./event-schedule.component.scss']
})
export class EventScheduleComponent implements OnInit {

  userInfo: any = {};
  userInfoSubscription: Subscription;
  userId: any;
  streamInfo: any = {};
  subEvents: any = [];
  selectedDate: any;
  selectedTabEvent: any;
  selectedDateIndex: any;
  selectedTabData: number;
  datesList: any = [];
  userColor: any = {};
  countUserColor = 0;
  guestList: any;
  selectedTab: any;
  ticketsData: any;
  currentLocation: any;
  getCurrency: any;
  getCurrencytype: any;
  expoInfo: any;
  ticketInfo: any;
  roomsList: any = [];
  streamAds: any;
  streamInfoData: any;

  streamAdsData: any;
  sponsorData: any;
  preloadAdsdata: any[];
  adVideo: any;
  allAds: any;
  eventHomeAdsTop: any[];

  streamAdsDataRight: any[];
  streamAdsDataTop: any[];
  streamAdsDataTopId: any[];
  streamAdsDataRightId: any[];
  eventHomeAdsRight: any[];
  streamingPageAdsRight: any[];
  streamingeventHomeAdsTop: any[];
  streamingPageAdsTop: any;
  duration: any;
  myList: { image: string; time: string; }[];
  adsImage: any;
  finalGuestsList: any;
  currentStreamStatusSubscr: Subscription;
  currentStreamStatus: any;
  timezoneVal: any;
  deviceInfo:any;
  assets_url = environment.assets_url;
  settingsDataSubscription: Subscription;
  settingsData: any = {};

  constructor(private router: Router,
    private ngxLoader: NgxUiLoaderService,
    private commonSubscribeService: CommanSubscribeService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    public toastr: ToastrService,
    private storageService: StorageService,
    private sanitizer: DomSanitizer,
    private appService: AppService,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.deviceInfo=this.commonSubscribeService.getMobileOperatingSystem()
    console.log(this.deviceInfo)
    if(this.deviceInfo=='android' || this.deviceInfo =='ios'){
      this.openPlaystore()
    }else{
    this.timezoneVal = this.userService.getTimezone();
    this.userInfo = this.commonSubscribeService.userInfo;
    this.userInfoSubscription = this.commonSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
    });
    this.commonSubscribeService.sendScreenStatus(false);
    this.userId = typeof (this.userInfo.id) == 'string' ? this.userInfo.id : JSON.stringify(this.userInfo.id);
    this.getEventInfo();
    // setTimeout(() => {
    //   this.loadAdsScript();
    // }, 1000);

    let userInfo = this.storageService.getItem('user_Info');
    let user = this.commonSubscribeService.userInfo;
    if (userInfo && userInfo.access_token && (!user || !user.id)) {
      this.getUser(userInfo.access_token);
    }
    this.currentStreamStatusSubscr = this.commonSubscribeService.getCurrentStreamStatus().subscribe(response => {
      this.currentStreamStatus = response;
      if (this.sortedEventsData.length > 0 && this.currentStreamStatus) {
        this.sortedEventsData.forEach(event => {
          if (event.stream_info.id == this.currentStreamStatus.sub_event_id)
            event.stream_info.stream_status = this.currentStreamStatus.status;
        })
        this.subEvents.forEach(event => {
          if (event.stream_info.id == this.currentStreamStatus.sub_event_id)
            event.stream_info.stream_status = this.currentStreamStatus.status;
        });
        const sorted = this.subEvents.sort((a, b) => a.stream_info.stream_status == 'progress' ? -1 : 1);
        this.subEvents = sorted;
      }
    });
  }
  this.settingsDataSubscription = this.commonSubscribeService.getICWebpageThemeSettings().subscribe(async (response) => {
    this.settingsData = response;
  });
  this.settingsData = this.commonSubscribeService.icWebpageSettingsData;
  }
  openPlaystore(){
    let data={
      userInfo:this.userInfo
    }
    const dialogRef = this.dialog.open(EventCheckoutDialog, {
      panelClass: 'event-checkout-dialog',
      disableClose: true,
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }
  loadAdsScript() {
    document.querySelectorAll('.videoAds').forEach(vid => (<HTMLVideoElement>vid).pause());
    $('.carousel-inner img').attr('alt', '');
    $('.carousel-inner img').attr('title', '');
    var t;

    var start = $('#myCarousel').find('.active').attr('id');
    t = setTimeout("$('#myCarousel').carousel({interval: 1000});", start - 1000);

    $('#myCarousel').on('slid.bs.carousel', function (ev) {
      clearTimeout(t);
      var duration1 = $(this).find('.active').attr('id');
      console.log(duration1);
      let slides = $(this).find('.carousel-item');
      let pvid = slides[ev.from].querySelectorAll('video')[0];
      if (pvid && (pvid != undefined || pvid != 'undefined')) {
        (<HTMLVideoElement>pvid).pause();
        pvid.currentTime = 0;
      }
      let vid = slides[ev.to].querySelectorAll('video')[0];
      if (vid && (vid != undefined || vid != 'undefined')) {
        vid.muted = true;
        (<HTMLVideoElement>vid).play();

      }
      $('#myCarousel').carousel('pause');
      t = setTimeout("$('#myCarousel').carousel();", duration1 - 1000);
    })

    $('.carousel-control-next').on('click', () => {
      clearTimeout(t);
    });

    $('.carousel-control-prev').on('click', () => {
      clearTimeout(t);
    });



    var r;

    var start = $('#RightCarousel').find('.active').attr('id');
    r = setTimeout("$('#RightCarousel').carousel({interval: 1000});", start - 1000);

    $('#RightCarousel').on('slid.bs.carousel', function (ev) {
      clearTimeout(r);
      var duration2 = $(this).find('.active').attr('id');
      console.log(duration2);
      let slides = $(this).find('.carousel-item');
      let pvid = slides[ev.from].querySelectorAll('video')[0];
      if (pvid && (pvid != undefined || pvid != 'undefined')) {
        (<HTMLVideoElement>pvid).pause();
        pvid.currentTime = 0;
      }
      let vid = slides[ev.to].querySelectorAll('video')[0];
      if (vid && (vid != undefined || vid != 'undefined')) {
        vid.muted = true;
        (<HTMLVideoElement>vid).play();

      }
      $('#RightCarousel').carousel('pause');
      r = setTimeout("$('#RightCarousel').carousel();", duration2 - 1000);
    })

    $('.carousel-control-next').on('click', () => {
      clearTimeout(r);
    });

    $('.carousel-control-prev').on('click', () => {
      clearTimeout(r);
    });
  }

  getUser(access_token) {

    let myInit = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${access_token}`
      },
      response: true,
      body: {
        // email: this.profileData.email,
        // user_id: this.userInfo.id
      }
    }
    // this.ngxLoader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_USER, myInit).then(response => {
      // this.ngxLoader.stop();
      let userInfo = response.data.user;
      userInfo.signedIn = true;
      userInfo.access_token = userInfo.session_token;
      userInfo.is_profile_completed = true;
      this.commonSubscribeService.sendUserInfo(userInfo);
    }).catch(error => {
      // this.ngxLoader.stop();      
      console.log(error);
      this.commonSubscribeService.sendUserInfo({});
    });
  }

  ticket_ids = [];
  ticketIdsResp = [];
  isVodPublished;
  getEventInfo() {
    this.getStreamInfo((response, hasTicket) => {
      if (response.data.message === "Success") {
        this.streamInfo = response['data']['Data']['stream_info']['stream_info'];        
        // this.getExpoList();
        this.guestList = response['data']['Data']['stream_info']['guestList'];
        this.finalGuestsList = this.guestList.filter(e => e.reveal_to_audience == 1);
        let subEvents = response['data']['Data']['stream_info']['subEvents'];
        this.ticket_ids = response['data']['Data']['ticket_ids'] || [];
        this.ticketIdsResp = response['data']['Data']['ticketIDs'] || [];
        if (subEvents && subEvents.length > 0) {
          const sortByDate = subEvents.sort((a, b) => a.publish_date_time > b.publish_date_time ? 1 : -1);
          const sorted = sortByDate.sort((a, b) => a.stream_info.stream_status == 'progress' ? -1 : 1);
          this.subEvents = sorted;
          this.subEvents.forEach(element => {
            element.finalGuestsList = [];
            if (element.stream_info) {
              // let localTime = moment.utc(element.stream_info.publish_date_time).toDate();
              // let startTime = moment(localTime).format('DD MMM YYYY');
              // let endTime = moment.utc(element.stream_info.expected_end_date_time).toDate();
              // let eventEndTime = moment(endTime).format('DD MMM YYYY');
              let localTime = moment.utc(element.stream_info.publish_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
              let startTime = localTime.format('DD MMM YYYY');
              let endTime = moment.utc(element.stream_info.expected_end_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
              let eventEndTime = endTime.format("DD MMM YYYY");
              if (moment(eventEndTime).isAfter(startTime)) {
                if (moment(eventEndTime).isAfter(startTime, 'year')) {
                  // element.stream_info.startTime = moment(localTime).format('DD MMM YYYY, hh:mm A');
                  // element.stream_info.endTime = moment(endTime).format('DD MMM YYYY, hh:mm A');
                  element.stream_info.startTime = localTime.format('DD MMM YYYY, hh:mm A');
                  element.stream_info.endTime = endTime.format('DD MMM YYYY, hh:mm A');
                }
                else {
                  // element.stream_info.startTime = moment(localTime).format('DD MMM, hh:mm A');
                  // element.stream_info.endTime = moment(endTime).format('DD MMM, hh:mm A');
                  element.stream_info.startTime = localTime.format('DD MMM, hh:mm A');
                  element.stream_info.endTime = endTime.format('DD MMM, hh:mm A');
                }
              } else {
                // element.stream_info.startTime = moment(localTime).format('hh:mm A');
                // element.stream_info.endTime = moment(endTime).format('hh:mm A');
                element.stream_info.startTime = localTime.format('hh:mm A');
                element.stream_info.endTime = endTime.format('hh:mm A');
              }
              if (element.stream_info.agenda && element.stream_info.agenda.length > 0) {
                element.stream_info.agenda.forEach(ag => {
                  let localTime = moment.utc(ag.start_time).toDate();
                  ag.start_time = moment(localTime).format('hh:mm A');
                  let localEndTime = moment.utc(ag.end_time).toDate();
                  ag.end_time = moment(localEndTime).format('hh:mm A');
                });
              }
            }
            if (element.guestList && element.guestList.length > 0) {
              element.guestList.forEach(guest => {
                guest.display_name = guest.first_name ? guest.first_name[0] : "";
                if (guest.last_name) {
                  guest.display_name += guest.last_name ? guest.last_name[0] : "";
                } else if (guest.first_name && guest.first_name[1]) {
                  guest.display_name += guest.first_name[1];
                }
                guest.userColor = this.getColor(guest);
                guest.shortName = this.getName(guest.display_name);
              });
              element.finalGuestsList = element.guestList.filter(e => e.reveal_to_audience == 1);
            }
          });
        }
        // if (this.streamInfo.event_dates_json) {
        this.streamInfo.event_dates_json = JSON.parse(this.streamInfo.event_dates_json);
        this.datesList = [...this.streamInfo.event_dates_json];
        let datesArr = [];
        if (this.subEvents.length > 0) {
          this.subEvents.forEach(event => {
            // let eventDate = moment.utc(event.stream_info.publish_date_time).toDate();
            // event.start = moment(eventDate).format('YYYY-MM-DD');
            let localTime = moment.utc(event.stream_info.publish_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
            event.start = localTime.format('YYYY-MM-DD');
            datesArr.push(event);
          });
        }
        this.datesList = [...new Map(datesArr.map(item =>
          [item['start'], item])).values()];
        this.datesList = this.datesList.sort((a, b) => a.publish_date_time > b.publish_date_time ? 1 : -1);
        if (this.datesList && this.datesList.length > 0) {
          this.datesList.forEach(date => {
            date.originalDate = date.start;
            date.start = moment(date.start).format("DD MMM");
            date.day = moment(date.originalDate).format("ddd");
          });
          if (this.selectedTabData >= 1) {
            this.selectedTabData = this.selectedDateIndex;
            this.onChangeDate(this.selectedTabEvent);
          } else {
            if (this.datesList && this.datesList.length > 0) {
              let event: any = {
                "index": 0,
                "tab": {
                  "textLabel": this.datesList[0].originalDate
                }
              }
              this.onChangeDate(event);
            }
          }
        }
        // }

      } else {
        this.router.navigateByUrl('page-not-found/404');
      }
    })
  }

  getGuestStream(callback) {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key
      },
      response: true,
      body: {
        "ticket_key": this.route.snapshot.params.ticket_key,
        "offset": new Date().getTimezoneOffset(),
        "timezone": this.timezoneVal
      }
    }
    // this.ngxLoader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_TICKET_DETAILS, data).then(response => {

      // this.ngxLoader.stop();
      console.log(response);
      if (response.data.statusCode === '200') {
        this.ticketInfo = response['data']['Data'];
        // this.commonSubscribeService.sendTicketDetails(response.data.Data);
        // let res = { data: { Data: response.data.Data.stream_info, statusCode: "200" } }
        let info = {
          'userId': response['data']['Data']['UserInfo']['id'],
          'slug': response['data']['Data']['stream_info']['slug']
        }
        this.getSlugInfo(info);
        this.commonSubscribeService.sendTicketDetails(response.data.Data);
        let date: any = new Date();
        date = date.getFullYear() - 20;
        this.commonSubscribeService.sendUserInfo(response.data.Data.UserInfo);
        response.data.Data.UserInfo.date_of_birth = date.toString() + "-01" + "-01";
        console.log(response.data.Data.UserInfo.date_of_birth);
        callback(response);
      } else {
        this.toastr.error("Invalid link");
        this.router.navigateByUrl('/');
      }
    }).catch(error => {
      this.ngxLoader.stop();
    });
  }

  getStreamInfo(callback) {
    let ticket_key = this.route.snapshot.params.ticket_key;
    let splits = ticket_key.split("-");
    let id = splits[0];
    console.log(id);
    if (splits.length > 1) {
      //guest user
      this.getGuestStream((data) => {
        callback(data, true);
      });
    } else {
      let ids, streamId, getId;
      let id = this.route.snapshot.params.ticket_key;
      let splits = id.split("-");
      if (splits && splits.length > 1) {
        id = splits[0];
      }
      if (this.route.snapshot.params.ticket_key && (this.route.snapshot.params.ticket_key.includes('?') || this.route.snapshot.params.ticket_key.includes('%'))) {
        getId = this.route.snapshot.params.ticket_key.split('?') || this.route.snapshot.params.ticket_key.split('%');
        streamId = getId[0];
      } else {
        streamId = id;
      }
      ids = {
        "stream_id": streamId,
        "userid": this.userInfo.id,
      }
      let data = {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": environment.AWS_Cognito.X_Api_Key,
          "Authorization": `Bearer ${this.userInfo.access_token}`
        },
        response: true,
        body: ids
      }
      this.ngxLoader.start();
      AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_LIVE_EVENT_BY_ID, data).then(response => {
        this.ngxLoader.stop();
        let hasTicket = response.data.Data.user_subscription_info.length > 0 ? true : false;
        callback(response, hasTicket);
      }).catch(error => {
        this.ngxLoader.stop();
        callback();
      });
    }
  }

  sortedEventsData = [];
  onChangeDate(event) {
    if (event && event.tab && event.tab.textLabel) {
      this.selectedTabEvent = event;
      this.selectedDateIndex = event.index;
      this.selectedDate = moment(event.tab.textLabel).format("YYYY-MM-DD");
      if (this.subEvents && this.subEvents.length > 0) {
        this.sortedEventsData = [];
        this.subEvents.forEach(event => {
          event.finalGuestsList = [];
          // let eventDate = moment.utc(event.stream_info.publish_date_time).toDate();
          // let s = moment(eventDate).format('YYYY-MM-DD');
          let localTime = moment.utc(event.stream_info.publish_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
          let s = localTime.format("YYYY-MM-DD");
          if (s == this.selectedDate) {
            event.isMatched = true;
            if (event.stream_info.agenda && event.stream_info.agenda.length > 0) {
              event.stream_info.agenda.forEach(ag => {
                if (ag.guest_ids && ag.guest_ids.length > 0) {
                  ag.guestList = [];
                  ag.guest_ids.forEach(guestid => {
                    if (event.guestList && event.guestList.length > 0) {
                      event.guestList.forEach(guest => {
                        if (guest.id == Number(guestid)) {
                          if (guest.first_name && guest.last_name) {
                            guest.display_name = guest.first_name[0];
                            if (guest.last_name) {
                              guest.display_name += guest.last_name[0];
                            } else if (guest.first_name[1]) {
                              guest.display_name += guest.first_name[1];
                            }
                            guest.userColor = this.getColor(guest);
                            guest.shortName = this.getName(guest.display_name);
                          }
                          ag.guestList.push(guest);
                          if (guest.reveal_to_audience == 1) {
                            event.finalGuestsList.push(guest);
                          }
                        }
                      });
                    }
                  });
                }
              });
            }
            this.sortedEventsData.push(event);
          } else {
            event.isMatched = false;
          }
        });
      }
    }
  }

  getName(name) {
    let returnString = "";
    if (name) {
      let a = name.split(" ");
      if (a.length > 1) {
        returnString = a[0].charAt(0);
        returnString += a[1].charAt(0);
        return returnString;
      } else if (name) {
        returnString = a[0].charAt(0);
        returnString += a[0].charAt(1);
        return returnString;
      } else {
        return returnString;
      }
    }
  }

  getColor(message) {
    let color = "";
    if (!this.userColor[message.id]) {
      color = COLORLIST[this.countUserColor];
      this.userColor[message.id] = COLORLIST[this.countUserColor];
      if (this.countUserColor > COLORLIST.length) {
        this.countUserColor = 0;
      } else {
        this.countUserColor++;
      }
    } else {
      color = this.userColor[message.id];
    }
    return color;
  }

  goToRespectiveScreen(streamInfo) {
    const channelName = this.router.url.split('/')[1];
    const segment2 = this.router.url.split('/')[2];
    const groupSlug = segment2 && !['event', 'channel', 'stream', 'watch', 'album', 'subscription-list'].includes(segment2) ? segment2 : '';
    const base = groupSlug ? `/${channelName}/${groupSlug}` : `/${channelName}`;
    if (streamInfo.stream_status == 'completed') {
      this.router.navigate([`${base}/watch/` + this.route.snapshot.params.ticket_key], { queryParams: { stage: streamInfo.id } });
    } else {
      this.router.navigate([`${base}/stream/` + this.route.snapshot.params.ticket_key], { queryParams: { stage: streamInfo.id } });
    }
  }

  getTicket(streamInfo) {
    const channelName = this.router.url.split('/')[1];
    const segment2 = this.router.url.split('/')[2];
    const groupSlug = segment2 && !['event', 'channel', 'stream', 'watch', 'album', 'subscription-list'].includes(segment2) ? segment2 : '';
    const base = groupSlug ? `/${channelName}/${groupSlug}` : `/${channelName}`;
    this.router.navigateByUrl(`${base}/event/${streamInfo.slug}/place-order/${this.route.snapshot.params.ticket_key}`);
  }

  getExpoList() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {}
    }
    let url = CONST_AWS_API.GET_EXPO_LIST + '/' + this.streamInfo.id;
    this.ngxLoader.start();
    AWS_API.get(environment.AWS_Cognito.apiName, url, data).then(response => {
      if (response.data.statusCode === '200') {
        this.ngxLoader.stop();
        this.expoInfo = response.data.Data;
        // this.getNetworkRoomsList();
        // else if(this.subEvents && this.subEvents.length == 1 && this.subEvents[0].stream_status =='completed' && this.expoInfo && this.expoInfo.length == 0)
        //   this.router.navigateByUrl('/userhome');
      }
    }).catch(error => {
      this.ngxLoader.stop();
    });

  }

  getSlugInfo(info) {
    let locInfo = this.commonSubscribeService.locationInfo;
    this.currentLocation = locInfo && Object.keys(locInfo).length > 0 ? locInfo : this.storageService.getItem('current_location');
    let id = typeof (this.userInfo.id) == 'string' ? this.userInfo.id : JSON.stringify(this.userInfo.id);
    if (!this.streamInfo || !this.streamInfo.displayAmounts) {
      this.commonSubscribeService.getCurrentLocation((val: any, json: any) => {
        console.log(json);
        if (val == "fail") {
          this.currentLocation = this.currentLocation ? this.currentLocation : { currency: {} };
        } else {
          this.currentLocation = json;
        }
        this.getCurrencytype = this.getCurrency ? this.getCurrency : this.currentLocation && this.currentLocation.currency ? this.currentLocation.currency.code : '';
        let data = {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": environment.AWS_Cognito.X_Api_Key,
            "Authorization": `Bearer ${this.userInfo.access_token}`,
          },
          response: true,
          body: {
            "slug": info.slug,
            "userid": info.userId,
            "offset": new Date().getTimezoneOffset(),
            "currency": this.getCurrency ? this.getCurrency : this.currentLocation && this.currentLocation.currency ? this.currentLocation.currency.code : '',
            "timezone": this.timezoneVal
          }
        }
        this.ngxLoader.start();
        AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_EVENT_BY_SLUG, data).then(response => {
          this.ngxLoader.stop();

          this.streamInfoData = response['data']['Data']['stream_info'];
          this.streamAds = this.streamInfoData['stream_ads'];
          this.eventDetails();
          this.commonSubscribeService.sendSlugData(response['data']['Data']);
          let org_past_event= response['data']['Data']['org_past_event'];
          this.isVodPublished = org_past_event ? org_past_event.split('_')[1] == 1 ? true : false : false;
          this.ticketsData = response['data']['Data']['tickets'];
          if (this.ticketsData) {
            this.subEvents.forEach(event => {
              this.ticketsData.forEach(element => {
                if (element.sessions && element.sessions.length > 0) {
                  if (element.sessions.includes(event.streamid)) {
                    event.isTicket = true;
                  }
                }
                if (this.ticketIdsResp.includes(element.id) && element.add_ons) {
                  event.enableTicket = true;
                }
              });
            });
          }
        }).catch(error => {
          this.ngxLoader.stop();
        });
      });
    }
  }

  eventDetails() {
    this.streamAds = this.streamInfo['stream_ads'];
    console.log('All ads from dynamo', this.streamAds);
    this.streamAdsData = [];
    if (this.streamAds && this.streamAds.length > 0) {
      this.streamAds.forEach(element => {
        if (element.ad_size && element.ad_size == "728x90" || element.ad_size == "300x600") {
          this.streamAdsData.push(element);
        }
      });
      console.log('Schedule page ads from dynamo', this.streamAdsData);
      if (this.streamAdsData.length > 0) {
        this.getAds();
      }
    }

  }


  selectedAdData: any;
  async getAds() {
    let allDiv = [];
    let count = 0;

    var temp_site_id = null;
    this.preloadAdsdata = [];
    if (this.streamAdsData && this.streamAdsData.length > 0) {
      this.sponsorData = this.streamAdsData;
      var j = 0;
      var i = 1;

      var adTypeIdarr = [];
      var placements = [];
      this.streamAdsData.forEach(el => {
        temp_site_id = Number(el.site_id)
        j += 1;
        adTypeIdarr.push(el.adTypeId);
        placements.push({
          "divName": "div" + i + j,
          "networkId": Number(environment.kevel.NETWORK_ID),
          "siteId": Number(el.site_id),
          "adTypes": [el.adTypeId],
          "campaignId": Number(el.campaignId),
          "flightId": Number(el.flight_id),
          "adId": Number(el.ad_id)
        });
        allDiv.push("div" + i + j);
        count = count + 1;
        if (this.streamAdsData.length == count) {
          let data = {
            "placements": placements,
            "allDiv": allDiv
          };
          if (temp_site_id) {
            this.eventHomeAdsTop = [];
            this.eventHomeAdsRight = [];
            this.streamingPageAdsRight = [];
            this.streamingPageAdsTop = [];
            this.commonSubscribeService.getAdsData(data, (err, result) => {
              this.preloadAdsdata = result.Ads_data;
              console.log("Schedule page Ads :::: ", this.preloadAdsdata);
              if (this.preloadAdsdata.length > 0) {
                this.preloadAdsdata.forEach(element => {
                  this.selectedAdData = element.clickUrl;
                  console.log('eventHomeAdsRight selectedAdData :: ', this.selectedAdData);
                  if (element.contents && element.contents[0] && element.contents[0].body && element.width == 728 && element.height == 90) {
                    let adType = element.contents[0];
                    let customData = adType.data['customData'] ? adType.data['customData'] : {};
                    let duration = adType['data']['customData']['maxPlayTime'];
                    this.adVideo = this.sanitizer.bypassSecurityTrustHtml(adType.body);
                    this.eventHomeAdsTop.push({ 'image': this.adVideo, 'duration': (duration * 1000) });
                    if (element.impressionUrl) {
                      this.commonSubscribeService.countAdsImpressions(element.impressionUrl);
                    }
                  }
                  if (element.contents && element.contents[0] && element.contents[0].body && element.width == 300 && element.height == 600) {
                    let adType = element.contents[0];
                    // let customData = adType.data['customData'] ? adType.data['customData'] : {};
                    let duration = adType['data']['customData']['maxPlayTime'];
                    let rightsadVideo = this.sanitizer.bypassSecurityTrustHtml(adType.body);
                    this.eventHomeAdsRight.push({ 'image': rightsadVideo, 'duration': (duration * 1000) });
                    if (element.impressionUrl) {
                      this.commonSubscribeService.countAdsImpressions(element.impressionUrl);
                    }
                  }
                });
                console.log('scheduleAdsTop :: ', this.eventHomeAdsTop);
                console.log('scheduleAdsRight :: ', this.eventHomeAdsRight);
                setTimeout(() => {
                  this.loadAdsScript();
                }, 200);
              }
            });
          }
        }
      });
    }
  }
  // async getAds_old() {
  //   let AdsDetails = [];
  //   let allDiv = [];
  //   let count = 0;

  //   var temp_site_id = null;
  //   this.preloadAdsdata = [];
  //   if (this.streamAdsData && this.streamAdsData.length > 0) {
  //     console.log("LIST_ADS result :: ", this.streamAdsData);
  //     this.sponsorData = this.streamAdsData;
  //     //////////////////////////////
  //     var j = 0;
  //     var i = 1;

  //     var adTypeIdarr = [];
  //     var placements = [];
  //     this.streamAdsData.forEach(el => {
  //       temp_site_id = Number(el.site_id)
  //       // if(this.siteId && this.siteId == el.site_id){
  //       // temp_site_id = Number(el.site_id)
  //       // }
  //       j += 1;
  //       adTypeIdarr.push(el.adTypeId);
  //       placements.push({
  //         "divName": "div" + i + j,
  //         "networkId": Number(environment.kevel.NETWORK_ID),
  //         // "siteId": (this.siteId == el.site_id) ? Number(el.site_id) : null,
  //         "siteId": Number(el.site_id),
  //         "adTypes": [el.adTypeId],
  //         "campaignId": Number(el.campaignId),
  //         "flightId": Number(el.flight_id),
  //         "adId": Number(el.ad_id)
  //       });
  //       allDiv.push("div" + i + j);
  //       count = count + 1;
  //       if (this.streamAdsData.length == count) {
  //         AdsDetails.push({
  //           "networkId": Number(environment.kevel.NETWORK_ID),
  //           "siteId": temp_site_id,
  //           "placement_data": placements,
  //         });
  //         console.log("AdsDetails ==> ", AdsDetails);
  //         let data = {
  //           "placements": AdsDetails.length > 0 ? AdsDetails : null,
  //           "allDiv": allDiv
  //           // "allDetails":JSON.stringify(AdsDetails)
  //         };
  //         if (temp_site_id) {
  //           this.eventHomeAdsTop = [];
  //           this.eventHomeAdsRight = [];
  //           this.streamingPageAdsRight = [];
  //           this.streamingPageAdsTop = [];
  //           this.appService.postRequest(API.GET_ADS, data).subscribe(result => {
  //             console.log("Ads result correct :::: ", result);
  //             this.preloadAdsdata = result.Ads_data;
  //             if (this.preloadAdsdata.length > 0) {
  //               let durationArr = [];
  //               this.preloadAdsdata.forEach(element => {
  //                 console.log("element :::::::::::::: ", element);
  //                 if (element.contents && element.contents[0] && element.contents[0].body && element.width == 728 && element.height == 90) {
  //                   let adType = element.contents[0];
  //                   let customData = adType.data['customData'] ? adType.data['customData'] : {};
  //                   console.log("customData :::::::::::::: ", customData);
  //                   // durationArr.push(adType['data']['customData']['maxPlayTime']);

  //                   let duration = adType['data']['customData']['maxPlayTime'];
  //                   this.adVideo = this.sanitizer.bypassSecurityTrustHtml(adType.body);
  //                   console.log("adVideo :::::::::::::: ", this.adVideo);
  //                   this.eventHomeAdsTop.push({ 'image': this.adVideo, 'duration': (duration * 1000) });
  //                   if(element.impressionUrl) {
  //                     this.commonSubscribeService.countAdsImpressions(element.impressionUrl);
  //                   }
  //                 }
  //                 if (element.contents && element.contents[0] && element.contents[0].body && element.width == 300 && element.height == 600) {
  //                   let adType = element.contents[0];
  //                   let customData = adType.data['customData'] ? adType.data['customData'] : {};
  //                   let duration = adType['data']['customData']['maxPlayTime'];
  //                   let rightsadVideo = this.sanitizer.bypassSecurityTrustHtml(adType.body);
  //                   this.eventHomeAdsRight.push({ 'image': rightsadVideo, 'duration': (duration * 1000) });
  //                   if(element.impressionUrl) {
  //                     this.commonSubscribeService.countAdsImpressions(element.impressionUrl);
  //                   }
  //                 }
  //               });
  //               // console.log('durationArray', durationArr);
  //               console.log('FROM LOAD PAGE', this.eventHomeAdsRight);
  //               // durationArr.sort((a, b) => {
  //               //   return a - b;
  //               // });
  //               // this.duration = durationArr[durationArr.length - 1];
  //               // console.log("durationHighestValue :::::::::::::: ", this.duration);
  //               // console.log("durationValues :::::::::::::: ", durationArr);
  //             }

  //           });
  //         }
  //       }
  //     });
  //   }
  // }
  getNetworkRoomsList() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {}
    }
    let url = CONST_AWS_API.GET_ROOMS_LIST + '/' + this.streamInfo.id;
    this.ngxLoader.start();
    AWS_API.get(environment.AWS_Cognito.apiName, url, data).then(response => {
      if (response.data.statusCode === '200') {
        console.log(response)
        this.ngxLoader.stop();
        if (response.data.Data) {
          this.roomsList = response.data.Data;
          if (this.subEvents && this.subEvents.length == 1 && this.expoInfo && this.expoInfo.length == 0 && this.roomsList && this.roomsList.length == 0) {
            // if (this.subEvents[0].stream_status =='completed') {
            //   this.router.navigate(['/watch/' + this.route.snapshot.params.ticket_key], { queryParams: { stage: this.subEvents[0].streamid } });
            // } 
            if (this.subEvents[0].stream_status != 'completed') {
              this.router.navigate([`${this.subEvents[0]?.channel_name}/stream/` + this.route.snapshot.params.ticket_key], { queryParams: { stage: this.subEvents[0].streamid } });
            }
          }
        }
      }
    }).catch(error => {
      this.ngxLoader.stop();
    });

  }

  ngOnDestroy() {
    if (this.userInfoSubscription)
      this.userInfoSubscription.unsubscribe();
    if (this.currentStreamStatusSubscr)
      this.currentStreamStatusSubscr.unsubscribe();
  }
  isPastEndTime(stream_info: any): boolean {
    if (!stream_info) {
      console.error('Invalid expected_end_date_time');
      return true;
    }
      const endTimeInCurrentTimeZone = moment
      .utc(stream_info['expected_end_date_time'], "YYYY-MM-DD HH:mm:ss")
      .tz(this.timezoneVal);
    return moment().tz(this.timezoneVal).isAfter(endTimeInCurrentTimeZone);
  }
}
